import {produce} from 'immer';
import {useAtom} from 'jotai';
import {aiPromptActiveItemAtom, aiPromptStackAtom} from '@/map/atom';

export const useAiPromptStack = () => {
  const [active, setActive] = useAtom(aiPromptActiveItemAtom);
  const [stack, setStack] = useAtom(aiPromptStackAtom);

  const createAiPrompt = (id: string) => {
    setStack(
      produce((draft) => {
        const index = draft.findIndex((d) => d === id);

        if (index !== -1) {
          draft.splice(index, 1);
        }

        draft.push(id);
      })
    );
    setActive({
      id,
      open: true,
    });
  };

  const removeAiPropmt = (id: string) => {
    setStack(
      produce((draft) => {
        const index = draft.findIndex((d) => d === id);
        if (index !== -1) draft.splice(index, 1);
      })
    );

    if (active.id === id) {
      setActive({
        open: false,
      });
    }
  };

  const toggleAiPrompt = () => {
    if (!active.open && !active.id && stack.length) {
      setActive({
        id: stack[stack.length - 1],
        open: true,
      });
    } else {
      setActive((prev) => ({
        ...prev,
        open: !prev.open,
      }));
    }
  };

  const clearAiPrompt = () => {
    setActive({open: false});
    setStack([]);
  };

  return {
    activeAiPropmptItem: active,
    hasStack: !!stack?.length,
    setActiveAiPromptItem: setActive,
    createAiPrompt,
    removeAiPropmt,
    toggleAiPrompt,
    clearAiPrompt,
  };
};
